import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.25 16.5h-.75A1.5 1.5 0 0 1 12 15v-3.75a.75.75 0 0 0-.75-.75h-.75"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M11.625 7.5a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25"
    }, null, -1)
  ]));
}
const interfaceAlertInformationCircle = { render };
export {
  interfaceAlertInformationCircle as default,
  render
};
//# sourceMappingURL=interface-alert-information-circle.svg.js.map
